import { Typography } from '@material-ui/core'
import styled from 'styled-components'

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 32px 24px;
`

export const Header = styled.div`
  margin-bottom: 24px;
`

export const Title = styled(Typography)`
  font-family: AvenirDemi !important;
  font-size: 22px !important;
  font-weight: 600 !important;
  color: #282e3c;
  margin-bottom: 4px !important;
`

export const SubTitle = styled(Typography)`
  font-family: Avenir !important;
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.6) !important;
`

export const Card = styled.div`
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 16px;
`

export const SectionLabel = styled.div`
  font-family: AvenirDemi;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.56);
  margin-bottom: 12px;
`

export const ColumnsRefRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin-bottom: 12px;
`

export const ColumnChip = styled.span`
  background-color: #fbf5ed;
  border-radius: 12px;
  padding: 3px 10px;
  font-family: Avenir;
  font-size: 12px;
  color: #282e3c;
`

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
`

export const Tab = styled.button`
  border: 0;
  background: transparent;
  font-family: AvenirDemi;
  font-size: 14px;
  padding: 12px 16px;
  cursor: pointer;
  color: ${(p) => (p.$active ? '#282e3c' : 'rgba(0, 0, 0, 0.56)')};
  border-bottom: 2px solid ${(p) => (p.$active ? '#282e3c' : 'transparent')};
  text-transform: lowercase;
`

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$cols || 3}, 1fr);
  gap: 12px;
  margin-bottom: 12px;
`

export const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`

export const LeftActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const FileName = styled.span`
  font-family: Avenir;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
`

export const RowCard = styled.div`
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;
  position: relative;
`

export const RowHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`

export const RowLabel = styled.span`
  font-family: AvenirDemi;
  font-size: 13px;
  color: #282e3c;
`

export const RemoveButton = styled.button`
  border: 0;
  background: transparent;
  color: #c43d3d;
  font-family: AvenirDemi;
  font-size: 12px;
  cursor: pointer;
  text-transform: lowercase;
`

export const CountsBar = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  padding: 12px 0;
  margin-bottom: 12px;
`

export const CountPill = styled.span`
  font-family: AvenirDemi;
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: ${(p) => p.$bg || '#f0f0f0'};
  color: ${(p) => p.$color || '#282e3c'};
`

export const StatusCell = styled.span`
  font-family: AvenirDemi;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  background-color: ${(p) =>
    p.$status === 'created'
      ? '#e7f5ec'
      : p.$status === 'dry_run'
      ? '#eef2fb'
      : p.$status === 'error'
      ? '#fdecec'
      : '#f0f0f0'};
  color: ${(p) =>
    p.$status === 'created'
      ? '#1f7a3a'
      : p.$status === 'dry_run'
      ? '#2f4ea0'
      : p.$status === 'error'
      ? '#a52525'
      : '#666'};
`

export const ResultMessage = styled.div`
  font-family: Avenir;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.7);
`

export const SummaryLine = styled.div`
  font-family: Avenir;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 4px;
`

export const Mono = styled.span`
  font-family: monospace;
  font-size: 12px;
`
